module.exports = __webpack_public_path__ + "static/img/KP.a6c8a945.svg";